import React, { useEffect, useState } from "react";
import $ from 'jquery';
import bootbox from 'bootbox';
import Toastr from 'toastr';
import logo from "./../assets/img/favicon-dark.png";
import Loading from "../components/Loading";
import CommonUtils from '../util/CommonUtils';
import API from '../service/SiteKickAPIService';

function VerifyChallenge() {

    let challenge = new URLSearchParams(window.location.search);
    let user_login = challenge.get('username');
    let reset_pwd_token = challenge.get('token');

    const [verifying, setVerifying] = useState(true);
    const [password, setPassword] = useState('');
    const [confirm_password, setConfirmPassword] = useState('');
    const [allow_reset, setAllowReset] = useState(false);

    useEffect(() => {
        verifyChallenge();
    }, []);

    const verifyChallenge = () => {
        CommonUtils.ajax(
            {
                url: API.AUTH.RESET_PASSWORD_CHALLENGE,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify({
                    operation: 'verify-token',
                    form_input: {
                        user_login: user_login,
                        reset_pwd_token: reset_pwd_token
                    }
                }),
                dataType: "json"
            }
        ).then((res) => {
            if (res && res.status) {
                switch (res.status.code) {
                    case 200:
                        setAllowReset(true);
                        setVerifying(false);
                        Toastr.success('You now can reset your password.', "Success");
                        break;

                    default:
                        setVerifying(false);
                        Toastr.error('Token expired or invalid !');
                        break;
                }
            } else {
                setVerifying(false);
                Toastr.error('Token expired or invalid !');
            }
            $('.btn-reset-pwd').removeClass('btn-loading');
        }, (err) => {
            setVerifying(false);
            $('.btn-reset-pwd').removeClass('btn-loading');
            Toastr.error('Attempt failed ... Please try again !');
        });

    }

    const resetPassword = () => {
        let allowedPattern = /^[0-9a-zA-Z!#@$]+$/;

        if (password.length < 8 || !allowedPattern.test(password)) {
            Toastr.error('Password should satisfy below: <br> 1. can contain alphabets, <br> 2. can contain numeric characters, <br> 3. can contain ! # @ $, <br> 4. should atleast be of 8 chars length', "Failure");
            return;
        }

        CommonUtils.ajax(
            {
                url: API.AUTH.RESET_PASSWORD_CHALLENGE,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify({
                    operation: 'reset-password',
                    form_input: {
                        password: password,
                        confirm_password: confirm_password,
                        user_login: user_login,
                        reset_pwd_token: reset_pwd_token
                    }
                }),
                dataType: "json"
            }
        ).then((res) => {
            if (res && res.status) {
                switch (res.status.code) {
                    case 200:
                        bootbox.alert('Your password has been reset successfully.', () => {
                            window.location = "/";
                        })
                        break;

                    default:
                        Toastr.error('Error while password reset. <br>Please contact SiteKick Support.', "Failure");
                        break;
                }
            } else {
                Toastr.error('Error while password reset. Please try again.', "Failure");
            }
            $('.btn-reset-pwd').removeClass('btn-loading');
        }, (err) => {
            $('.btn-reset-pwd').removeClass('btn-loading');
            Toastr.error('Attempt failed ... Please try again !');
        });

    }

    const handleInputChange = (e) => {
        const target = e.target;

        switch (target.name) {
            case "password":
                setPassword(target.value);
                break;
            case "confirm_password":
                setConfirmPassword(target.value);
                break;
            default:
                break;
        }
    };

    return (
        <React.Fragment>
            <div className="container mt-5" style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                {verifying ? <Loading>Validating request ... </Loading> : ""}
                {allow_reset &&
                    <div className="row">
                        <div className="col-md-12 col-xs-12 p-2">
                            <div className="text-center">
                                <span className="logo-font font-size-20 text-app-2 strong">
                                    <img
                                        className="pb-1 "
                                        src={logo}
                                        alt="logo"
                                        style={{ width: "30px", marginRight: "10px" }}
                                    />
                                    SiteSupt OnDemand
                                </span>
                            </div>
                            <br />
                            <div className="card m-4" style={{ width: "20rem" }}>
                                <div className="card-body">
                                    <h6 className="text-center text-bold">Reset Password</h6>
                                    <div className="d-flex align-items-center flex-column mt-5">
                                        <div>
                                            <label className="py-0 my-0 mt-3 text-app-2 font-size-16"> Password </label>
                                            <input
                                                className="form-control"
                                                style={{ width: "18rem" }}
                                                type="password"
                                                name="password"
                                                value={password}
                                                onChange={handleInputChange}
                                                autoComplete="off"
                                                placeholder="Password"
                                            />
                                        </div>
                                        <div>
                                            <label className="py-0 my-0 mt-3 text-app-2 font-size-16"> Confirm Password </label>
                                            <input
                                                className="form-control"
                                                style={{ width: "18rem" }}
                                                type="password"
                                                name="confirm_password"
                                                value={confirm_password}
                                                onChange={handleInputChange}
                                                autoComplete="off"
                                                placeholder="Confirm Password"
                                            />
                                        </div>
                                    </div>
                                    <div className="text-right">
                                        <button disabled={!(password.trim()).length > 0 || !(confirm_password.trim()).length > 0 || password !== confirm_password} className="btn btn-sm btn-app-2 mt-2 btn-reset-pwd" onClick={resetPassword}>Submit</button>
                                    </div>
                                    <div className="left-right mt-3">
                                        <i className="fas fa-arrow-left text-app-2"></i>
                                        <a href="./"> Back to Login </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>

        </React.Fragment>
    );
}
export default VerifyChallenge;
